import { ThemeInterface } from "@styles/theme";

export const styles = (theme: ThemeInterface) => ({
	root: {
		"& .MuiSelect-select": {
			fontSize: "14px",
		},
	},
	textBox: {
		width: "288px",
		marginTop: "0",
		marginBottom: "0",
		fontSize: "10px",
		"& .MuiOutlinedInput-root": {
			width: "100%",
		},
		"& .MuiOutlinedInput-input": {
			fontSize: "14px",
			padding: "10.5px 14px",
		},
	},
	textBoxDisable: {
		opacity: ".4",
	},
	prefix: {
		"& p": {
			color: theme.palette.grey[900],
			fontWeight: "600",
		},
	},
	iconClass: {
		width: "20px",
		height: "20px",
		marginRight: "1rem",
		verticalAlign: "middle",
	},
	noBorderRoot: {},
	noBorderFocused: {},
	noBorderNotchedOutline: {
		border: "none",
	},
	scheduleTextField: {
		width: "208px",
	},
	scheduleDropDown: {
		width: "120px",
		marginLeft: "16px",
	},
	width288: {
		width: "288px",
	},

	retryDetails: {
		width: "114px",
		height: "90px",
		marginRight: "7px",
	},
	appendText: {
		fontSize: "14px",
		marginRight: "5px",
		padding: "7px",
	},
	prependTextStyle: {
		padding: "0px 10px",
		marginTop: "8px",
	},
	appendTextRelativeTo: {
		marginLeft: "13px",
		color: theme.palette.primary.main,
	},
	customIcon: {
		color: theme.palette.primary.main,
		margin: "8px",
	},
	searchBox: {
		width: "95%",
		display: "flex",
		margin: "auto",
		"& .MuiInputBase-root": {
			height: "42px",
		},
		marginBottom: "8px",
	},
	searchLoader: {
		width: "24px !important",
		height: "24px !important",
		display: "block",
		margin: "12px auto",
	},
	selectRoot: {
		minHeight: "150px",
		maxHeight: "550px",
		maxWidth: "310px",
	},
	menuItem: {
		whiteSpace: "initial",
		wordBreak: "break-word",
	},
	width600: {
		width: "600px ",
	},
});

export default styles;
